export enum USER_CREATION_ACTIONS {
  CREATE = 0,
  EDIT = 1,
  REQUEST = 2
}
